module.exports = __webpack_public_path__ + "img/ppt.a886ce16.svg";